import { render, staticRenderFns } from "./CreateTemplateModal.vue?vue&type=template&id=5730d28a&"
import script from "./CreateTemplateModal.vue?vue&type=script&lang=js&"
export * from "./CreateTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports